export default __webpack_public_path__ + "static/media/ic-person.ae13c03c.svg";